import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs/index';
import {ApprovalPending} from '../dto/approval-pending';
import {ApprovalModel} from '../dto/approval.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class BlacklistService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers;
  public model = new EventEmitter<NgbModal>();
  public closeModel: NgbModal;
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/searchRequestData', data);
  }

  searchRequestBlackListData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/searchRequestBlackListData', data);
  }

  searchSuspendedRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/searchSuspendedData', data);
  }

  getAllRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/getRequestData', data);
  }

  getAllReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/getReturnRequest', data);
  }

  getAllDGReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/getDGReturnRequest', data);
  }

  searchPendingRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/searchPendingRequests', data);
  }

  searchApplicantDetails(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'blacklist/getApplicantDetails/'+ applicationId);
  }

  approveRequeat(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/approveRequest', approvalModel, {headers: this.headers});
  }

  getPendingVerificationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'blacklist/getPendingRequests' ,approvalModel, {headers: this.headers});
  }

  getDGSuspendedRequests(): Observable<Object>{
    return this.httpClient.get(this.baseUrl + 'blacklist/getSuspended');
  }

  getPendingAuthorizationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'blacklist/getPendingAuthList',approvalModel, {headers: this.headers});
  }

  returnRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/returnRequest', approvalModel, {headers: this.headers});
  }

  saveDocumentTypeAndDetails(details) {
    return this.httpClient.post<any>(this.baseUrl + 'blacklist/saveDocumentDetails', details);
  }

  approvalProcess(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'blacklist/approve', approvalModel, {headers: this.headers});
  }

  close() {
    this.closeModel.dismissAll();
  }
}
